// Stripe product and price IDs for CompliGUARD tiers
export const STRIPE_TIERS = {
  entry: {
    name: "Starter",
    product_id: "prod_U6sndvlBt2iLcv",
    price_id: "price_1T8f2ES5Ach2ENPKSXQsDJGP", // $0/mo AUD subscription (card required)
    price_display: "Free",
    free_reviews: 2,
    max_skus: 1,
  },
  lite: {
    name: "CompliGUARD Lite",
    product_id: "prod_Uj1zR5kuW5ccaT",
    price_id: "price_1TjZw8S5Ach2ENPKci5h9xYh", // $29/mo AUD (ANTA members)
    price_display: "$29/mo",
    max_skus: 0, // not applicable for practitioner-type plan
    monthly_review_limit: 2,
    clinic_profiles: 1,
  },
  practitioner_solo: {
    name: "Practitioner",
    product_id: "prod_UMvJgisDvnXW70",
    price_id: "price_1TOBSjS5Ach2ENPKVMzNmtAI", // $59/mo AUD
    price_display: "$59/mo",
    max_skus: 0, // not applicable for practitioner
    monthly_review_limit: 6,
    clinic_profiles: 1,
  },
  practitioner: {
    name: "Practitioner PLUS",
    product_id: "prod_UF8HPNusciJvlO",
    price_id: "price_1TGe0dS5Ach2ENPKXjvrhjh9", // $149/mo AUD
    price_display: "$149/mo",
    max_skus: 0, // not applicable for practitioner
    clinic_profiles: 2,
  },
  review_credit: {
    name: "Review Credit",
    product_id: "prod_U6srFnxKJW8Sjv",
    price_id: "price_1T8f5oS5Ach2ENPKCfSMIiLi", // $50 AUD one-time per review
    price_display: "$50/review",
  },
  solo_brand: {
    name: "Solo Brand",
    product_id: "prod_V3w3vKQxlhFSBy",
    price_id: "price_1U3oBjS5Ach2ENPKGbSOSuBg", // $199/mo AUD
    price_display: "$199/mo",
    max_skus: 1,
  },
  duo_brand: {
    name: "Duo Brand",
    product_id: "prod_VXHOxb9Rd8Jhyc",
    price_id: "price_1UWCpgS5Ach2ENPKDiQHHzwc", // $299/mo AUD (private plan, not on pricing page)
    price_display: "$299/mo",
    max_skus: 2,
  },
  professional: {
    name: "Professional Brand",
    product_id: "prod_U6stuhKf2TToF1",
    price_id: "price_1T8f89S5Ach2ENPKEOJdhqXc", // $599/mo AUD
    price_display: "$599/mo",
    max_skus: 5,
  },
  growth: {
    name: "Growth Brand",
    product_id: "prod_U6svmcYQRxtPiF",
    price_id: "price_1T8f9CS5Ach2ENPKWt5D5Trw", // $999/mo AUD
    price_display: "$999/mo",
    max_skus: 20, // 10 included, extras at $50/mo each up to 20
    included_skus: 10,
  },
  extra_sku: {
    name: "Extra Product Add-On",
    product_id: "prod_U7vWZJHY6yW6Oh",
    price_id: "price_1T9ffDS5Ach2ENPKzrjnT1YJ", // $50/mo AUD per extra product
    price_display: "$50/mo per product",
  },
  scale: {
    name: "Scale Brand",
    product_id: "prod_U6svlbHMK1l5qr",
    price_id: "price_1T8f9tS5Ach2ENPKARjt7okT", // $2,500/mo AUD
    price_display: "$2,500/mo",
    max_skus: 50,
  },
  enterprise: {
    name: "Enterprise",
    product_id: "",
    price_id: "",
    price_display: "POA",
    max_skus: 9999,
  },
} as const;

// Map product IDs to tier keys for lookup from Stripe responses
export const PRODUCT_ID_TO_TIER: Record<string, keyof typeof STRIPE_TIERS> = {
  [STRIPE_TIERS.entry.product_id]: "entry",
  [STRIPE_TIERS.lite.product_id]: "lite",
  [STRIPE_TIERS.practitioner_solo.product_id]: "practitioner_solo",
  [STRIPE_TIERS.practitioner.product_id]: "practitioner",
  [STRIPE_TIERS.solo_brand.product_id]: "solo_brand",
  [STRIPE_TIERS.duo_brand.product_id]: "duo_brand",
  [STRIPE_TIERS.professional.product_id]: "professional",
  [STRIPE_TIERS.growth.product_id]: "growth",
  [STRIPE_TIERS.scale.product_id]: "scale",
  "prod_ULMtDFtVjyIWlY": "growth", // Custom Growth product for imnutrients
};
